//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'


//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const rubricSelector = (state) => state.rubrices;

//  -- Examples array selector --------

export const useRubrices = () => {
    const selectedData = useSelector(rubricSelector, shallowEqual);
    return selectedData;
}
